const styles = {
  description: {
    color: 'kit.text.secondary',
    marginBottom: {
      xs: '16px',
      xl: '24px',
    },
  },
  list: {},
  itemText: {
    marginLeft: '-4px',
  },
  points: {
    color: 'kit.text.main',
    marginBottom: {
      xs: '24px',
      xl: '40px',
    },
  },
};

export default styles;
